// Tooltip content for question mark icons on property forms

export const LISTING_STATUS_TOOLTIP = `LISTING STATUS NOTES:

The listing statuses that are considered "Dynamic Listing Statuses":
• ACTIVE
• PENDING
• OFF MARKET
• INCOMPLETE

The listing statuses that are considered "Passive Listing Statuses" (they are also called "permanent" or "final" states of a listing):
• SOLD
• RENTED
• CANCELLED
• EXPIRED

More notes on Listing Status field:

Once a listing goes into one of the "Dynamic" statuses:
• RCR agents can modify the statuses of the listings and the information in the listing records in the dynamic statuses.

Once a listing goes into one of the "Passive" (final) statuses:
• RCR agents can modify/correct the information in the listing records in these statuses.
• RCR agents cannot modify the statuses of the listing records in these passive statuses. The RCR agents are not allowed to change listing statuses of the listings in the "passive" statuses to protect the integrity of the RCR database.
• Project Admin can modify the listing statuses and the information in the listings in these passive statuses. This means that, if a listing status in these passive status needs to be changed (this may happen time to time), RCR agent needs to ask the Project Admin to do the change.`;

export const COUNTY_PROPERTY_ID_TOOLTIP = `COUNTY PROPERTY ID NOTES:

• There can be many MLS listings using the same Property Id.
• For each Property Id, there can be only one active listing for sale and only one active listing for rent. For example, we cannot have 2 active listings for sale with the same Property Id because a home can be listed by only one agent (there can only be one home for sale listing).
• Many rented listings and many sold listings may have the same COUNTY PROPERTY ID (provided that each having a unique MLS Listing Number).
• This field has many names in public: Property id, parcel number, folio number, property control number (PCN), property identification number (PIN or PID), etc.`;

export const SHORT_ADDRESS_TOOLTIP = `SHORT ADDRESS NOTES:

• SFH home type: The house number, direction, street name, post direction.
  Example: 123 SW Main Street W.

• Condo home type: The field value will consist of only the condo identifier (such as the community letter/name/number used in the address) plus the unit number.
  Examples:
  - G-603 (using the community letter "G" plus the unit number)
  - Daisy-501 (using the community name "Daisy" plus the unit number "501")
  - 2700/561 (using the address number "2700" plus the unit number "561")

• Townhome, Villa, CoachHome home types: The "SHORT ADDRESS" definition for Townhome, Villa, CoachHome will depend on the type of the community. Sometimes they will look like the "SHORT ADDRESS" for SFHs or THs or Coach Homes and other times they will look like the "SHORT ADDRESS" for Condo home type.

OTHER SHORT ADDRESS NOTES:

• "SHORT ADDRESS" field is created because we needed a shorter address to keep the "ADDRESS" field column on the matrix narrow.
• The "SHORT ADDRESS" data shall be listed in the "ADDRESS" column of the matrices on RCR Home pages or anyplace else needed.`;
